import { useState } from "react";
import { EVoucherAddToCusWidgetStyled } from "./styled";
import { MdAssignmentAdd } from "react-icons/md";
import { portalService } from "apiServices";
import { Displays, Forms, Modals } from "components";
import { toast } from "react-toastify";

const EVoucherAddToCusWidget = ({
  reward_id,
  reward_e_voucher_id,
  onSuccess,
}) => {
  const [_isBgLoading, _setIsBgLoading] = useState(false);
  const [_isShowModal, _setIsShowModal] = useState(false);

  const _handleClickModal = async () => {
    _setIsShowModal(true);
  };
  const _handleCloseModal = async () => {
    _setIsShowModal(false);
  };

  const _handleSubmit = async (values) => {
    _setIsBgLoading(true);
    let params = {
      ...values,
      customer_ref_id: values.customer_ref_id._id,
      reward_id,
      reward_e_voucher_id,
    };
    let res = await portalService.POST_REWARD_E_VOUCHER_ADMIN_REDEEM(params);
    if (res && res.status === 200) {
      _setIsBgLoading(false);
      toast.success("Redeem success");
      onSuccess && onSuccess();
    } else {
      _setIsBgLoading(false);
      toast.error("Redeem invalid");
    }
  };

  return (
    <>
      <Displays.BGLoading visible={_isBgLoading} />
      <EVoucherAddToCusWidgetStyled onClick={_handleClickModal}>
        <MdAssignmentAdd size={22} color="#4b1e78" />
      </EVoucherAddToCusWidgetStyled>
      <Modals.BodyEmpty
        isShowModal={_isShowModal}
        onCloseModal={_handleCloseModal}
      >
        <Forms.EVoucherAddToCusForm
          onClose={_handleCloseModal}
          onSubmit={_handleSubmit}
        />
      </Modals.BodyEmpty>
    </>
  );
};

export default EVoucherAddToCusWidget;
